import configApi from '@/config';

// Разделитель значений параметра в url
const splitSymbol = '_';
const FILTER_NAME = configApi.FILTER_LOCAL_STORAGE + 'UrlBack';

const addToUrlNewParams = (name, value) => {
  const url = new URL(window.location.href);
  url.searchParams.set('filter', '1');
  url.searchParams.set(name, value);
  return url.toString();
};

export default {
  // Записывает параметры фильтров в url
  toUrl(filterData = {}, toUrlString = false) {
    if (!Object.keys(filterData).length) return;

    if ('URLSearchParams' in window) {
      let filter = {};
      let newRelativePathQuery = window.location.pathname;
      const url = !toUrlString ? window.location.search : '';

      filter['filter'] = 1;
      filter = { ...filter, ...filterData };

      const searchParams = new URLSearchParams(url);

      Object.keys(filter).map((param) => {
        if (param === 'route') return;

        if (!filter[param]) {
          return searchParams.delete(param);
        }
        if (Array.isArray(filter[param])) {
          if (!filter[param].length) {
            return searchParams.delete(param);
          }
          return searchParams.set(param, '_' + filter[param].join(splitSymbol));
        }

        searchParams.set(param, filter[param]);
      });

      if (toUrlString) {
        return (
          filter['route'] +
          (searchParams.toString() ? '?' + searchParams.toString() : '')
        );
      }

      if (Array.from(searchParams).length > 1) {
        newRelativePathQuery += '?' + searchParams.toString();
      }

      history.pushState(null, '', newRelativePathQuery);
    }
  },
  // Переводит параметры url в объект
  toObject(url) {
    if ('URLSearchParams' in window) {
      const params = {};
      const searchParams = new URLSearchParams(url);

      searchParams.forEach((value, key) => {
        if (value.indexOf(splitSymbol) + 1) {
          return (params[key] = value.split(splitSymbol).slice(1));
        }
        params[key] = value;
      });

      return params;
    }
  },
  // Загружает фильтр с Url в обьект
  getUrlFilter(queryFilter) {
    if (queryFilter) {
      return this.toObject(window.location.search);
    }
    return {};
  },
  // Загружает фильтр с localStorage в ссылку
  getUrlBack() {
    const filterJSON = localStorage.getItem(FILTER_NAME);

    if (filterJSON) {
      let filterData = {};
      filterData = JSON.parse(window.atob(filterJSON));
      return this.toUrl(filterData, true);
    }
  },
  // Сохраняет фильтр в localStorage
  saveFilter() {
    const data = this.toObject(
      window.location.search + '&route=' + window.location.pathname
    );
    localStorage.setItem(FILTER_NAME, window.btoa(JSON.stringify(data)));
  },
  // Удаляем фильтр
  deleteFilter() {
    localStorage.removeItem(FILTER_NAME);
  },

  saveToUrlParams(params) {
    if (!Object.keys(params).length) return;

    if ('URLSearchParams' in window) {
      let urlPathName = window.location.pathname;
      const oldUrlParams = window.location.search;

      const searchParams = new URLSearchParams(oldUrlParams);

      Object.keys(params).forEach((key) => {
        searchParams.set(key, params[key]);
      });

      if (Array.from(searchParams).length) {
        urlPathName += '?' + searchParams.toString();
      }

      history.pushState(null, '', urlPathName);
    }
  },

  changeUrlParams(name, value) {
    const newUrl = addToUrlNewParams(name, value);
    window.history.replaceState(null, '', newUrl);
    return newUrl;
  },

  addToUrlParams(name, value) {
    const newUrl = addToUrlNewParams(name, value);
    window.history.pushState(null, '', newUrl);
    return newUrl;
  },

  getParamFromUrl(name) {
    const url = new URLSearchParams(window.location.search);
    return url.get(name);
  },

  deleteParamFromUrl(name) {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(window.location.search);
    let params = '';

    searchParams.delete(name);

    if (searchParams.toString()) {
      params = `?${searchParams.toString()}`;
    }

    const newUrl = new URL(
      `${url.origin}${url.pathname}${params}`
    ).toString();

    window.history.replaceState(null, '', newUrl);

    return newUrl;
  },
};
